// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCommentForm_form__2Te8b","loading":"NewCommentForm_loading__2veC2","control":"NewCommentForm_control__3NVeP","actions":"NewCommentForm_actions__2fwWP"};